import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export interface PostExamsPointsRequest {
    teamId: number;
    results: [
        {
            student_id: number;
            year: 2022 | 2023;
            exam_type: 'OGE' | 'EGE'; // сейчас только огэ (31.05.2023)
            points: number; // 0-19 для огэ
            score?: number; // 0-5 (оценки без баллов не может быть)
        }
    ];
}

export function postExamsPoints({ teamId, results }: PostExamsPointsRequest): Promise<void> {
    const { apiPostExamsPoints } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostExamsPoints}${teamId}/`, { results });
}
